export const Messages = {
  routeChange: "routeChange",
  sizeChange: "sizeChange",
};
